

export const setSignupCity = (signupCity) => (   
  {
    type: 'SET_SIGNUP_CITY',
    signupCity,
  }    
)

export const setSignupCities = (signupCities) => (   
  {
    type: 'SET_SIGNUP_CITIES',
    signupCities,
  }    
)

export const setProductActionSelectionList = (productActionSelectionList) => (   
  {
    type: 'SET_PRODUCT_ACTION_SELECTION_LIST',
    productActionSelectionList,
  }    
)

export const setProductActionSelection = (productActionSelection) => (   
  {
    type: 'SET_PRODUCT_ACTION_SELECTION',
    productActionSelection,
  }    
)

export const setFileContent = (fileContent) => (
  {
    type: 'SET_FILE_CONTENT',
    fileContent
  }
);

export const setFileContentTwo = (fileContentTwo) => (
  {
    type: 'SET_FILE_CONTENT_TWO',
    fileContentTwo
  }
);

export const setAdminProductUploadStatus = (adminProductUploadState) => (
  {
    type: 'SET_ADMIN_PRODUCT_UPLOAD_STATE',
    adminProductUploadState  
  }
);

export const setAdminProductUploadResponse = (adminProductUploadResponse) => (
  {
    type: 'SET_ADMIN_PRODUCT_UPLOAD_RESPONSE',
    adminProductUploadResponse  
  }
);

